import { TGetProvincesAndMunicipalitiesResDto } from "@/api/services/global/constant/dtos/get-provinces-municipalities.dto";
import { globalApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";

const LOCAL_STORAGE_KEY = "zipCodeCache";

type ZipCodeCache = Record<string, TGetProvincesAndMunicipalitiesResDto>;

const getCache = (): ZipCodeCache => {
  const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!raw) return {};
  try {
    return JSON.parse(raw);
  } catch {
    return {};
  }
};

const setCache = (zipCode: string, data: TGetProvincesAndMunicipalitiesResDto) => {
  const cache = getCache();
  cache[zipCode] = data;
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cache));
};

export const fetchPrefectureAndMunicipalityByZipCodeApi = async (zipCode: string): Promise<TGetProvincesAndMunicipalitiesResDto> => {
  const cache = getCache();
  if (cache[zipCode]) {
    return cache[zipCode];
  }

  const url = createUrlWithParams("/prefecture-and-municipality-by-zipcode", { zipCode });
  const rs = await globalApi.get(url);
  const data = rs.data.data;

  setCache(zipCode, data);
  return data;
};
